var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{staticClass:"login-page m-0"},[_c('b-col',{staticClass:"p-0 left-col",attrs:{"md":"8","sm":"12"}},[_c('LeftColumn')],1),_c('b-col',{staticClass:"right-col",attrs:{"md":"4","sm":"12"}},[_c('RightColumn')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }